{
	"NavigationAll": "All",
	"NavigationReporting": "Reporting",
	"InsightsHub": "Insights",
	"Presence": "Presence",
	"NavigationAdministration": "Administration",
	"NavigationEasyProvisioning": "Easy Provisioning",
	"NavigationDevices": "Devices",
	"NavigationEndpoints": "Endpoints",
	"NavigationTrunking": "Trunking",
	"NavigationHospitality": "Hospitality",
	"NavigationTrunkgateways": "Trunk Gateways",
	"NavigationVoicemailservices": "Voice Mail Services",
	"NavigationConferencedevices": "Conference Devices",
	"NavigationAgents": "Agents",
	"NavigationDirectory": "Directory",
	"NavigationCodes": "Codes",
	"NavigationPartitions": "Partitions",
	"NavigationTelephonyservers": "Telephony Servers",
	"NavigationCmenvironments": "Central Management Environments",
	"NavigationApplicationusers": "Application Users",
	"NavigationOmnichannel": "Omnichannel",
	"NavigationRecording": "Recording",
	"NavigationMessages": "Messages",
	"NavigationDatabase": "Database",
	"NavigationStatustools": "Status & Tools",
	"NavigationLicenses": "Licences",
	"NavigationLogging": "Logging",
	"NavigationLogmanagement": "Log Management",
	"NavigationAudittrail": "Audit Trail",
	"NavigationTelephonemodulestatus": "Telephone Module Status",
	"NavigationCallcontrol": "Call Control",
	"NavigationServerstatus": "Server Status",
	"NavigationNewAnalytics": "Add Enterprise Company",
	"NavigationManageUsersDevice": "Manage Users",
	"NavigationManageQueues": "Manage Queues",
	"NAME": "LanguageMainNavigation"
}